import { api } from "..";

import { QueryProps } from "@/types/Api";
import { PlayerCoupon } from "@/types/ApiResponses/Coupon";

interface Params {
  couponId: string;
  lang: string;
}

export const getCoupon = async (
  props: QueryProps<Params>
): Promise<PlayerCoupon> => {
  const { couponId, lang } = props.params;
  const res = await api.client.get(`/coupon-new/${couponId}`, {
    signal: props.signal,
    params: { lang },
  });
  return res.data;
};
